module.exports = "pegasus_template/assets/restaurant-logo.png";